import { render, staticRenderFns } from "./Mincetur.vue?vue&type=template&id=3d067ff4&"
import script from "./Mincetur.vue?vue&type=script&lang=js&"
export * from "./Mincetur.vue?vue&type=script&lang=js&"
import style0 from "./Mincetur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports